// extracted by mini-css-extract-plugin
module.exports = {"introImg":"about-me-module--introImg--2fJSW","intro":"about-me-module--intro--3EShD"};